export default "__VITE_ASSET__oW5K445s__"